import { render, staticRenderFns } from "./BoxSelect.vue?vue&type=template&id=706df831&scoped=true&"
import script from "./BoxSelect.vue?vue&type=script&lang=js&"
export * from "./BoxSelect.vue?vue&type=script&lang=js&"
import style0 from "./BoxSelect.vue?vue&type=style&index=0&id=706df831&scoped=true&lang=css&"
import style1 from "./BoxSelect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706df831",
  null
  
)

export default component.exports